module.exports = __webpack_public_path__ + "static/agenciesEmployeeHandbook-6b6d430613539439b12033e26c438fc7.png";